import Typography from '@material-ui/core/Typography'
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    reminderHeader: {
        marginTop: theme.spacing(1),
        marginLeft: 6,
        fontSize: '0.875rem',
        fontWeight: 'bold',
        color: '#505E71',
        '& span': {
            fontWeight: 'normal',
        },
    },
}))

const ConsumerCheckoutPurchaseReminder = () => {
    const classes = useStyles()
    return (
        <>
            <Typography
                variant="h6"
                gutterBottom
                component="div"
                className={classes.reminderHeader}
            >
                Reminder
                <span>&nbsp;For use in USA only</span>
            </Typography>
        </>
    )
}

export default ConsumerCheckoutPurchaseReminder
